import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button } from '@volvo/vcdk-react';

import EmptyState from '@/components/EmptyState';
import ManageUnitsFleetModal from '@/components/modals/ManageUnitsFleetModal';
import { useFleetAccount } from '@/contexts/fleet-account/useFleetAccount';
import FleetCard from '@/routes/_authenticated/_account/fleets/_components/FleetCard';
import { getFleetsQueryOptions } from '@/service/vpc/queryOptions';

export const Route = createFileRoute('/_authenticated/_account/fleets/')({
  component: FleetUnitsPage,
  loader: async (opts) => {
    const fleetAccountId = opts.context.fleetAccountId;
    if (!fleetAccountId) {
      return; // Return early if no fleet account is selected yet
    }
    return await opts.context.queryClient.ensureQueryData(getFleetsQueryOptions({ fleetAccountId }));
  },
});

function FleetUnitsPage() {
  // const { t } = useTranslation();
  const navigate = useNavigate();
  const { fleetAccountId } = useFleetAccount();

  const { data: fleets, isLoading, isFetched } = useQuery(getFleetsQueryOptions({ fleetAccountId: fleetAccountId! }));

  if (isLoading || !isFetched) {
    return <></>;
  }

  if (fleets && fleets.length === 0) {
    return (
      <EmptyState
        title="No fleet created yet"
        message="Create fleet to group your units in a way that makes sense to you, such as by vehicle type, location, or use case."
        actions={
          <>
            <Button
              variant="secondary"
              onClick={() => {
                navigate({ to: '/units' });
              }}
            >
              Unit overview
            </Button>
            <ManageUnitsFleetModal operation="new" preSelectedRows={{}} />
          </>
        }
      />
    );
  }

  return (
    <div className="flex flex-col gap-6">
      <div className="flex justify-end">
        <ManageUnitsFleetModal operation="new" preSelectedRows={{}} />
      </div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {fleets?.map((fleet) => (
          <FleetCard key={fleet.fleetId} id={fleet.fleetId} name={fleet.name} entityVersion={fleet.entityVersion} />
        ))}
      </div>
    </div>
  );
}
